var map = {
	"./advania.png": 373,
	"./aranja.svg": 374,
	"./bloomberg.svg": 375,
	"./ccp.png": 376,
	"./google.png": 377,
	"./highcharts.png": 378,
	"./landsbankinn.jpg": 379,
	"./mozilla.svg": 380,
	"./tempo.svg": 381,
	"./ueno.png": 382,
	"./upperquad.png": 383,
	"./viewsourceconf.jpg": 384
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 372;



/*****************
 ** WEBPACK FOOTER
 ** ../images/sponsors ^\.\/.*$
 ** module id = 372
 ** module chunks = 0
 **/